import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../jSONSchema7Properties';
import PageState from '../pageState';

export default (
  controlSchemaId: string,
  pages: PageState[],
  customId: string
) => {
  let isUnique = true;
  // iterate through pages
  pages.forEach((page: PageState) => {
    const pageProperties = page.schema.properties as JSONSchema7Properties;
    // iterate through controls
    Object.getOwnPropertyNames(pageProperties).map((propName: string) => {
      const controlSchema = pageProperties[propName] as JSONSchema7;
      const controlProperties =
        controlSchema.properties as JSONSchema7Properties;
      if (
        controlSchema.$id !== controlSchemaId &&
        controlProperties['id'].default === customId
      ) {
        isUnique = false;
        return;
      }
    });
    if (!isUnique) return;
  });
  return isUnique;
};
